import { FunctionComponent } from "react";
import Navbar from "../components/Navbar";
import SpecialOfferText from "../components/SpecialOfferText";
import BackgroundElementText from "../components/BackgroundElementText";
import LogoRectangle from "../components/LogoRectangle";

const Index1: FunctionComponent = () => {
  return (
    <div className="w-full relative bg-white overflow-hidden flex flex-col items-start justify-start pt-0 px-0 pb-[2055px] box-border gap-[51px] tracking-[normal] mq800:gap-[25px]">
      <Navbar />
      <section className="self-stretch h-[1514px] bg-white overflow-y-auto shrink-0 flex flex-col items-start justify-start max-w-full mq1350:h-auto">
        <div className="self-stretch flex flex-col items-start justify-start gap-[41px] max-w-full shrink-0 mq800:gap-[20px]">
          <SpecialOfferText />
          <BackgroundElementText />
        </div>
        <LogoRectangle />
      </section>
    </div>
  );
};

export default Index1;
